(function(){
'use strict';

var CORREAS = [
  'https://cdn.shopify.com/s/files/1/0685/0714/0247/files/Gemini_Generated_Image_qv9bzkqv9bzkqv9b.png?v=1782323696',
  'https://cdn.shopify.com/s/files/1/0685/0714/0247/files/Gemini_Generated_Image_qv9bzkqv9bzkqv9b_4.png?v=1782323697',
  'https://cdn.shopify.com/s/files/1/0685/0714/0247/files/Gemini_Generated_Image_qv9bzkqv9bzkqv9b_2.png?v=1782323696',
  'https://cdn.shopify.com/s/files/1/0685/0714/0247/files/Gemini_Generated_Image_qv9bzkqv9bzkqv9b_1.png?v=1782323696',
  'https://cdn.shopify.com/s/files/1/0685/0714/0247/files/Gemini_Generated_Image_qv9bzkqv9bzkqv9b_3.png?v=1782323696',
  'https://cdn.shopify.com/s/files/1/0685/0714/0247/files/Gemini_Generated_Image_jtfe9djtfe9djtfe.png?v=1782323696',
];
var BILLETERAS = [
  'https://cdn.shopify.com/s/files/1/0685/0714/0247/files/Gemini_Generated_Image_68gejj68gejj68ge.png?v=1782320307',
  'https://cdn.shopify.com/s/files/1/0685/0714/0247/files/Gemini_Generated_Image_o66e06o66e06o66e.png?v=1782320308',
  'https://cdn.shopify.com/s/files/1/0685/0714/0247/files/Gemini_Generated_Image_68gejj68gejj68ge_1.png?v=1782320307',
  'https://cdn.shopify.com/s/files/1/0685/0714/0247/files/Gemini_Generated_Image_68gejj68gejj68ge_2.png?v=1782320307',
];
function rnd(arr){ return arr[Math.floor(Math.random()*arr.length)]; }

var PRODS = [
  {
    name:'Lecler District',
    img:'https://cdn.shopify.com/s/files/1/0685/0714/0247/files/1a765236-f381-4f58-8dc7-dba3c50864d4.jpg?v=1782317401',
    sizes:[
      {t:'38',id:'47946831560855',s:2},{t:'39',id:'47946831593623',s:1},
      {t:'40',id:'47946831626391',s:2},{t:'41',id:'47946831659159',s:1},
      {t:'42',id:'47946831691927',s:1},
    ]
  },
  {
    name:'Lecler Urban Volt',
    img:'https://cdn.shopify.com/s/files/1/0685/0714/0247/files/Gemini_Generated_Image_p0jn5fp0jn5fp0jn_2.png?v=1782318616',
    sizes:[
      {t:'39',id:'47946837819543',s:2},{t:'40',id:'47946837852311',s:3},
      {t:'41',id:'47946837885079',s:3},{t:'42',id:'47946837917847',s:3},
      {t:'43',id:'47946837950615',s:2},{t:'44',id:'47946852761751',s:2},
    ]
  },
  {
    name:'Lecler Juno Negro',
    img:'https://cdn.shopify.com/s/files/1/0685/0714/0247/files/ChatGPT_Image_18_abr_2026_21_25_26.png?v=1776612775',
    sizes:[
      {t:'38',id:'46414920843415',s:1},{t:'39',id:'46414920876183',s:2},
      {t:'40',id:'46414920908951',s:0},{t:'41',id:'46414920941719',s:1},
      {t:'42',id:'46414920974487',s:3},{t:'43',id:'46414921007255',s:2},
      {t:'44',id:'46414921040023',s:2},
    ]
  },
  {
    name:'Lecler Versalles Azul',
    img:'https://cdn.shopify.com/s/files/1/0685/0714/0247/files/DSC02019.jpg?v=1780688835',
    sizes:[
      {t:'37',id:'46159725002903',s:0},{t:'38',id:'46159725035671',s:2},
      {t:'39',id:'46159725068439',s:3},{t:'40',id:'46159725101207',s:3},
      {t:'41',id:'46159725133975',s:0},{t:'42',id:'46159725166743',s:0},
      {t:'43',id:'46159725199511',s:1},{t:'44',id:'46159725265047',s:0},
    ]
  },
];

var aM=0, aSz=-1, qty=1;

function renderSwatches(){
  var r=document.getElementById('lc-swr'); if(!r) return;
  r.innerHTML=PRODS.map(function(p,i){
    return '<div class="lc-sw'+(i===aM?' on':'')+'" data-i="'+i+'" title="'+p.name+'"><img src="'+p.img+'" loading="lazy"></div>';
  }).join('');
  r.querySelectorAll('.lc-sw').forEach(function(el){
    el.addEventListener('click',function(){aM=+el.dataset.i;aSz=-1;renderSwatches();renderProduct();renderSizes();sync();});
  });
}

function renderProduct(){
  var p=PRODS[aM];
  var ph=document.getElementById('lc-ph'); if(ph) ph.innerHTML='<img src="'+p.img+'" alt="'+p.name+'">';
  var nm=document.getElementById('lc-nm'); if(nm) nm.textContent=p.name;
}

function renderSizes(){
  var p=PRODS[aM];
  var w=document.getElementById('lc-szw'); if(!w) return;
  w.innerHTML=p.sizes.map(function(s,i){
    var c='lc-t'+(i===aSz?' on':'')+(s.s===0?' off':'');
    return '<div class="'+c+'" data-i="'+i+'">'+s.t+'</div>';
  }).join('');
  w.querySelectorAll('.lc-t:not(.off)').forEach(function(el){
    el.addEventListener('click',function(){aSz=+el.dataset.i;renderSizes();sync();});
  });
}

function renderGifts(){
  var fc=document.getElementById('lc-fc');
  if(fc) fc.innerHTML='<img src="'+rnd(CORREAS)+'" alt="Correa"><figcaption>Correa sorpresa</figcaption>';
  var fb=document.getElementById('lc-fb');
  if(fb) fb.innerHTML='<img src="'+rnd(BILLETERAS)+'" alt="Billetera"><figcaption>Billetera sorpresa</figcaption>';
  var oc=document.getElementById('lc-obs-c');
  if(oc) oc.innerHTML='<img src="'+rnd(CORREAS)+'" alt="Correa">';
  var ob=document.getElementById('lc-obs-b');
  if(ob) ob.innerHTML='<img src="'+rnd(BILLETERAS)+'" alt="Billetera">';
}

function renderGallery(){
  var gal=document.getElementById('lc-gal');
  if(!gal){ return; }
  var all=[];
  CORREAS.forEach(function(u){ all.push({u:u,t:'Correa'}); });
  BILLETERAS.forEach(function(u){ all.push({u:u,t:'Billetera'}); });
  // shuffle
  for(var i=all.length-1;i>0;i--){
    var j=Math.floor(Math.random()*(i+1));
    var x=all[i];all[i]=all[j];all[j]=x;
  }
  gal.innerHTML=all.map(function(o){
    return '<div class="lc-gal-item"><img src="'+o.u+'" alt="'+o.t+'" loading="lazy"><div class="lc-gal-lbl">'+o.t+'</div></div>';
  }).join('');
}

function sync(){
  var p=PRODS[aM];
  var url=aSz>=0?'/cart/'+p.sizes[aSz].id+':'+qty:'#talla';
  var label=aSz>=0?'COMPRAR AHORA — $299.900':'SELECCIONA TU TALLA';
  document.querySelectorAll('.lc-buy').forEach(function(el){el.href=url;el.textContent=label;});
}

var qm=document.getElementById('lc-qm'), qp=document.getElementById('lc-qp');
if(qm) qm.addEventListener('click',function(){if(qty>1){qty--;document.getElementById('lc-qv').textContent=qty;sync();}});
if(qp) qp.addEventListener('click',function(){qty++;document.getElementById('lc-qv').textContent=qty;sync();});

document.querySelectorAll('.lc-faq-q').forEach(function(b){
  b.addEventListener('click',function(){
    var it=b.closest('.lc-faq-item'),o=it.classList.contains('open');
    document.querySelectorAll('.lc-faq-item').forEach(function(x){x.classList.remove('open');});
    if(!o) it.classList.add('open');
  });
});

// Countdown
var DUR=13*3600+20*60,stored=sessionStorage.getItem('lc4e'),endTs=stored?+stored:Date.now()+DUR*1000;
if(!stored) sessionStorage.setItem('lc4e',endTs);
function tick(){
  var r=Math.max(0,Math.floor((endTs-Date.now())/1000));
  var h=String(Math.floor(r/3600)).padStart(2,'0'),m=String(Math.floor((r%3600)/60)).padStart(2,'0'),s=String(r%60).padStart(2,'0');
  ['lc-H','lc-H2'].forEach(function(id){var e=document.getElementById(id);if(e)e.textContent=h;});
  ['lc-M','lc-M2'].forEach(function(id){var e=document.getElementById(id);if(e)e.textContent=m;});
  ['lc-S','lc-S2'].forEach(function(id){var e=document.getElementById(id);if(e)e.textContent=s;});
}
tick();setInterval(tick,1000);

// ── Init con reintento — por si GemPages carga el DOM tarde ─────────────
function init(){
  renderSwatches();
  renderProduct();
  renderSizes();
  renderGifts();
  renderGallery();
  sync();
  // Si la galería quedó vacía, reintentar en 500ms
  var gal=document.getElementById('lc-gal');
  if(gal && gal.children.length===0){
    setTimeout(function(){renderGallery();},500);
  }
}

if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

})();